// Agent-specific English strings stay split from the oversized source locale.
export const agentChip = {
  menuLabel: "Agent menu",
  agents: "Agents",
  showAll: "Show all",
  seeAllAgents: "See all agents",
  namedSettings: "{name} settings",
  agentSettings: "Agent settings",
  newConversation: "New conversation",
  workspaceMenuLabel: "Workspace menu",
  switchAgent: "Switch agent",
  working: "Working…",
  ready: "Ready to chat",
  whatCanAgentDo: "What can {name} do?",
  help: "Help",
  getHelp: "Get help",
  getApps: "Get the apps",
  discord: "Discord community",
  viewChangelog: "View changelog",
};

export const agentScope = {
  label: "Agent",
  allAgents: "All agents",
};

export const pinning = {
  pinToSwitcher: "Pin to switcher",
  unpinFromSwitcher: "Unpin from switcher",
};

export const identity = {
  title: "Identity",
  subtitle: "Name, emoji, and avatar shown in chats and the sidebar.",
  name: "Display name",
  namePlaceholder: "Agent name",
  emoji: "Emoji",
  chooseEmoji: "Choose emoji",
  searchEmoji: "Search emoji…",
  noEmojiMatches: "No matching emoji",
  chooseAvatar: "Edit avatar",
  avatarPicker: "Avatar picker",
  avatarPreview: "Avatar preview",
  avatarSource: "Avatar source",
  avatarBot: "Blobster",
  avatarGenerate: "Generate",
  avatarUpload: "Upload",
  avatarReset: "Reset",
  avatarPresets: "All Blobster presets",
  avatarPrompt: "Describe your blobster...",
  avatarUse: "Use avatar",
  avatarDiscard: "Discard",
  avatarRegenerate: "Generate again",
  avatarGenerating: "Generating...",
  avatarPreparing: "Preparing avatar…",
  avatarPermission: "Connect with permission to update agent identity to generate an avatar.",
  avatarContextChanged: "The selected agent or connection changed. Generate an avatar again.",
  avatarUploadHint: "Choose an image up to 2 MB. It will be resized for chats and the sidebar.",
  chooseImage: "Choose image…",
  replaceImage: "Replace image…",
  imageUnusable: "That image can't be used. Pick an image file up to 2 MB.",
  imageTooDetailed:
    "That image is too detailed to store as an avatar. Try a simpler image, or set a workspace image path with openclaw agents set-identity --agent <id> --avatar <path>.",
  fileHint: "Saving mirrors identity fields to IDENTITY.md; configured values take precedence.",
};
